import { connect } from 'react-redux';
import CetakLaporanPemasukanUang from '../../../views/Library/LaporanPemasukanUang/CetakLaporanPemasukanUang.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(CetakLaporanPemasukanUang);
